import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export default {
  __name: 'App',
  setup(__props) {
    // 纯净版：客服入口逻辑已停用。

    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_van_back_top = _resolveComponent("van-back-top");
      const _component_van_config_provider = _resolveComponent("van-config-provider");
      return _openBlock(), _createBlock(_component_van_config_provider, {
        theme: "dark"
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view), _createVNode(_component_van_back_top, {
          right: "5vw",
          bottom: "15vh"
        })]),
        _: 1
      });
    };
  }
};